import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;

// Detect E2E test environment
const isE2E = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  // Playwright sets this
  (window as unknown as { __PLAYWRIGHT__?: boolean }).__PLAYWRIGHT__ === true ||
  // Check for Playwright user agent
  navigator.userAgent.includes('Playwright') ||
  // Check for test mode in URL
  window.location.search.includes('e2e=true')
);

export function initPostHog() {
  // Skip PostHog in E2E tests to avoid flooding events
  if (isE2E) {
    console.info('[PostHog] Disabled in E2E/localhost environment');
    return;
  }

  if (!POSTHOG_KEY) {
    console.warn('[PostHog] No API key found (VITE_PUBLIC_POSTHOG_PROJECT_TOKEN). Analytics disabled.');
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    // Use memory persistence - no cookies/localStorage, no consent banner needed
    // Session replays work within a single page session (ideal for mobile app in WebView)
    persistence: 'memory',
    capture_pageview: true,
    capture_pageleave: true,
    // Session recording - enabled, console logs captured
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
      maskTextSelector: undefined,
    },
    // Capture console logs for debugging
    capture_console_logs: 'all',
  } as any);
}

export { posthog };
